import { Component, OnInit } from '@angular/core';
import { LayoutService } from '@apps/ui';

@Component({
  selector: 'sc-christmas-lights',
  templateUrl: './christmas-lights.component.html',
  styleUrls: ['./christmas-lights.component.scss']
})
export class ChristmasLightsComponent implements OnInit {

  constructor(public layout: LayoutService) { }

  ngOnInit() {
  }

}
